import { ApiError } from "@/pages/auth/api";
import { API_BASE_URL } from "@/shared/config/apiBaseUrl";

import type { OpeningSeedPreview, OpeningSeedSource } from "./openingSeedTypes";

type PreviewOpeningSeedPayload = {
  source: OpeningSeedSource;
  moves?: string[];
  pgn?: string;
  selectedPly?: number;
  label?: string | null;
};

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let detail = `request failed with status ${response.status}`;
    try {
      const payload = (await response.json()) as { detail?: string };
      if (payload.detail) {
        detail = payload.detail;
      }
    } catch {
      // Keep fallback message when the response body is not JSON.
    }
    throw new ApiError(detail, response.status);
  }

  return (await response.json()) as T;
}

export async function previewOpeningSeed(
  payload: PreviewOpeningSeedPayload,
): Promise<OpeningSeedPreview> {
  const response = await fetch(`${API_BASE_URL}/api/play-model/opening-seed/preview`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      source: payload.source,
      moves: payload.moves ?? [],
      pgn: payload.pgn ?? null,
      selected_ply: payload.selectedPly ?? null,
      label: payload.label ?? null,
    }),
  });

  return parseJson<OpeningSeedPreview>(response);
}
